(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AgreementValuationDeleteController',AgreementValuationDeleteController);

    AgreementValuationDeleteController.$inject = ['$uibModalInstance', 'entity', 'AgreementValuation'];

    function AgreementValuationDeleteController($uibModalInstance, entity, AgreementValuation) {
        var vm = this;
        vm.agreementValuation = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            AgreementValuation.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
